import { render, staticRenderFns } from "./BindingMenuComponent.vue?vue&type=template&id=932cb2c4&scoped=true"
import script from "./BindingMenuComponent.vue?vue&type=script&lang=ts"
export * from "./BindingMenuComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932cb2c4",
  null
  
)

export default component.exports